"use client";

import { useState } from "react";
import Image from "next/image";
import styles from "./BudgetFilter.module.scss";
import Text from "@components/atoms/Text";
import DualRangeSlider from "@components/atoms/DualRangeSlider";
import { BudgetFilterProps } from "./BudgetFilter.types";
import { formatPrice } from "@utils/numberFormatter";
import assetLoader from "@utils/internalImageLoder";

const BudgetFilter = ({
  title,
  minValue,
  maxValue,
  onChange,
  step,
  className = "",
  filterOptions
}: BudgetFilterProps) => {

  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div className={`${styles.container} ${className}`}>
      { title && (
        <div className={styles.header} onClick={() => setIsOpen(!isOpen)} >
          <Text className={styles.title}>{title}</Text>
          {isOpen ? (
            <Image
              src={`${assetLoader()}/icons/Chevron_up_dark.svg`}
              alt="Collapse"
              width={20}
              height={20}
            />
          ) : (
            <Image
              src={`${assetLoader()}/icons/Chevron_down_dark.svg`}
              alt="Expand"
              width={20}
              height={20}
            />
          )}
        </div>
      )}

      {
        isOpen && (
          <div className={styles.budgetToggle} >
            <DualRangeSlider
              minValue={minValue}
              maxValue={maxValue}
              min={filterOptions?.budget?.default_min_price || 0}
              max={filterOptions?.budget?.default_max_price || 0}
              step={step}
              onChange={onChange}
            />

            <div className={styles.valueDisplay}>
              <div className={styles.priceBox}>{formatPrice(minValue)}</div>
              <div className={styles.priceBox}>{formatPrice(maxValue)}</div>
            </div>
          </div>
        )
      }

    </div>
  );
};

export default BudgetFilter; 